@if (loading$ | async) {
<ish-loading [fullPage]="true" />
} @if (user$ | async; as user) { @if (user?.availableSoldTos?.length) {
<div [ngClass]="(deviceType$ | async) === 'desktop' ? 'sales-rep-users-con' : 'sales-rep-users-box'">
  <ng-select
    #customerSelect
    [items]="customersToDisplay"
    bindLabel="companyName"
    bindValue="customerNo"
    [placeholder]="currentCustomer"
    (change)="onSelection($event)"
    [clearOnBackspace]="false"
  />
</div>
} }

<!-- Customer Switch Confirmation Modal -->
<custom-sales-rep-customer-switch-confirmation-modal
  #confirmationModal
  (confirmed)="onConfirmSwitch($event)"
  (cancelled)="onCancelSwitch()"
/>
